<template>
  <span
    class="app-logo"
    :class="[`app-logo--${variant}`, { 'app-logo--with-text': withText }]"
    :style="{
      '--app-logo-size': `${size}px`,
    }"
  >
    <svg
      class="app-logo__mark"
      viewBox="0 0 48 48"
      role="img"
      :aria-label="ariaLabel"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{{ ariaLabel }}</title>
      <!-- Rounded container -->
      <rect x="4" y="4" width="40" height="40" rx="12" class="app-logo__tile" />

      <!-- Abstract "P" + receipt notch -->
      <path
        class="app-logo__glyph"
        d="M18 14.5c0-1.38 1.12-2.5 2.5-2.5H27c4.14 0 7.5 3.36 7.5 7.5S31.14 27 27 27h-5.5v6.5c0 1.38-1.12 2.5-2.5 2.5S16.5 34.88 16.5 33.5V14.5H18Zm9 8.5c1.93 0 3.5-1.57 3.5-3.5S28.93 16 27 16h-5.5v7H27z"
      />

      <!-- Check badge -->
      <path
        class="app-logo__badge"
        d="M34.5 30.5a6 6 0 1 1-12 0a6 6 0 0 1 12 0Z"
      />
      <path
        class="app-logo__badge-check"
        d="M26.9 30.7l1.6 1.6 3.9-4"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2.4"
      />
    </svg>

    <span v-if="withText" class="app-logo__text">
      {{ text }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'AppLogo',
  props: {
    variant: {
      type: String,
      default: 'dark', // dark on light backgrounds; use "light" on dark hero gradients
      validator: (v) => ['dark', 'light'].includes(v),
    },
    size: {
      type: Number,
      default: 40,
    },
    withText: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'PosSmart',
    },
    ariaLabel: {
      type: String,
      default: 'PosSmart',
    },
  },
};
</script>

<style scoped>
.app-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  line-height: 1;
}

.app-logo__mark {
  width: var(--app-logo-size);
  height: var(--app-logo-size);
  flex: 0 0 auto;
}

.app-logo__text {
  font-family: 'Poppins', 'Noto Sans Lao', 'Sarabun', sans-serif;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-size: 1.125rem;
}

/* Dark variant (light surfaces) */
.app-logo--dark .app-logo__tile {
  fill: #7c3aed;
}
.app-logo--dark .app-logo__glyph {
  fill: #ffffff;
}
.app-logo--dark .app-logo__badge {
  fill: #f97316;
}
.app-logo--dark .app-logo__badge-check {
  stroke: #ffffff;
}
.app-logo--dark .app-logo__text {
  color: #4c1d95;
}

/* Light variant (dark/gradient surfaces) */
.app-logo--light .app-logo__tile {
  fill: rgba(255, 255, 255, 0.14);
}
.app-logo--light .app-logo__glyph {
  fill: #ffffff;
}
.app-logo--light .app-logo__badge {
  fill: #ffffff;
  opacity: 0.92;
}
.app-logo--light .app-logo__badge-check {
  stroke: #7c3aed;
}
.app-logo--light .app-logo__text {
  color: #ffffff;
}
</style>
